import {
  Component,
  OnInit,
  ChangeDetectionStrategy, EventEmitter, Output, ViewChild, ViewContainerRef, ChangeDetectorRef, Inject
} from '@angular/core';
import { ResolvableComponent } from '@ispm/core/decorators/resolvable-component.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { FormHandlerService } from '@ispm/dynamic-form/services/form-handler.service';
import { ItemSelectionService } from '@ispm-client/modules/selection-item/services/item-selection.service';
import { FormGroup } from '@angular/forms';
import { Subject} from 'rxjs/Rx';
import { SearchService } from '@ispm/dynamic-form/services/search.service';
import { isEmpty, isEqual, get, cloneDeep, findIndex, set, groupBy, find, includes,sortBy, filter } from 'lodash';
import { GetItemsDataService } from '@ispm-client/modules/selection-item/services/get-items-data.service';
import { GetModelContextService } from '@ispm-client/modules/selection-item/services/get-model-context.service';
import {DataNotificationService} from '@ispm-client/modules/selection-item/services/data-notification.service';
import {
  IsubItemsPayLoad, Iitem,
  IshowRecommendedList, IrestrictItems, IgenericSelectionItem, ItypeTreeList
} from '@ispm-client/modules/selection-item/interfaces/floatingPanel.interface';
import {ConfirmModalLoaderPayload} from "@ispm/layout/classes/confirm-modal-loader-payload";
import {ModalTypes} from "@ispm/layout/components/modals/contants/modal-types.enum";
import {ConfirmModalComponent} from "@ispm/layout/components/modals/confirm-modal/confirm-modal.component";
import {DynamicModalLoaderService} from "@ispm/layout/services/dynamic-modal-loader.service";
import {BundleCall} from "@ispm-client/modules/aggregator/services/bundleCall.service";

import {TabsHeaderComponent} from '@ispm/layout/components/tabs-header/tabs-header.component';
import {TabData} from "@ispm/dynamic-form/interfaces/TabConfiguration";
import {Itab} from "@ispm/shared/interfaces/Itab";
import { Store } from '@ngrx/store';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import {AdditionalConfigurationService} from "@ispm/shared/services/additionalConfiguration.service";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {DashboardService} from "../../../../app/worklist/services/dashboard.service";
import { take } from 'rxjs/operators';

@Component({
  selector: 'generic-selection-item',
  templateUrl: './generic-selection-item.component.html',
  styleUrls: ['./generic-selection-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

@ResolvableComponent()
export class GenericSelectionItemComponent implements OnInit, IWidgetItem {
  public itemsData: any = [];
  public dataModelKeys: any = { };
  public datamodelAttributes: any = { };
  public datamodelAttributesPayload: any = { };
  public configSearchRequest: any = [];
  public datamodelContext: any = [];
  public intentDataNotificationForm: string = null;
  public configQuery: string;
  public loading: boolean = true;
  public noData: boolean = false;
  public organSelection: boolean = true;
  public noDataMessage: string = '';
  public treeItems: Map<string, Array<any>> = new Map<string, Array<any>>();
  public intentTotalSelectedItems: Map<string, Array<any>> = new Map<string, Array<any>>();
  public itemsAndNotesQueryPayload: Map<object, Array<any>> = new Map<object, Array<any>>();
  public intent: string = null;
  public tabIntentLabel: string = null;
  public intentCategory: string = null;
  public switchToNewIntent: string = null;
  public selectionPanelHeight: string;
  private _isInoEnabled: boolean = false;

  // 'itemOrderIndex' attribute allows to override the default sortByItem. This allows to set through a configuration a
  //  different sort-by index for a specific categoryItem while other items will keep sorted by the sortByItem.
  //  For example, if setting a itemOrderIndex to a high value, this categoryItem will be positioned last while other
  //    elements are sorted by their name
  public overrideSortByItem: string = 'itemOrderIndex';
  public sortByItem: string = 'itemName';
  public sortByIndex: string = 'sortIndex';
  public recommendedListItem: string = null;
  public expandCollapseRequired: boolean;
  public expandRecommendedList: boolean;
  public disableFirstLevel: boolean;
  public tabConfiguration: Array<any>;
  public saveOnlyOneIntent: boolean = false;
  public showTextAreaBottom: Array<string> = [];

  public context: any = { };
  public permitItemSelectionWrite: boolean;
  public widgetUpdateValueCallback: (value) => void;
  public _widgetData: any[] = [];
  protected destroyed$: Subject<void> = new Subject();
  public additionalSearchValues: any = { };
  public categoryItemtList: Array<Iitem> = [];
  public itemsCount: any = { };
  public totalSelectedItemList:  Array<Iitem> = [];
  public itemDeleted:boolean = false;
  public showRecommendedList: IshowRecommendedList;
  public intentOrStage: string = null;
  public fetchDataBasedOn: string = null;
  public fetchStageData: string = null;
  public treeItemsWithIntent: any;
  private init: boolean = false;
  private workflowTestType: string = null;
  public groupedSelectedItems: any = { };

  public subSelectionPanelClose: boolean = false;
  public subItems: IsubItemsPayLoad;
  public selectedSubItemList: any = [];
  public restrictItems: IrestrictItems;
  public selectionType: string;
  public pncStatus:boolean = false;
  public organData: any;
  public organContext: any;
  public currentOrgan: any;
  public hideDecisions: boolean = false;
  private decisionConfigCached: Map<string, any> = new Map();

  @Output() subItemsOpen: EventEmitter<any> = new EventEmitter();
  @ViewChild('genericSubSelection', { static: false, read: ViewContainerRef }) entry: ViewContainerRef;

  currentTabTitle: string;
  tabs: Itab[] = [];
  tabConfig: Array<any> = [];
  tabContainer: Array<TabData> = [];
  formConfig: any[];
  disabled: boolean = false;
  dataUpdated: boolean = false;
  isTabInitialised: boolean = false;
  public data;
  public formData: any;
  @ViewChild(TabsHeaderComponent, {static: false}) tabsHeaderComponent: TabsHeaderComponent;

  public _widgetFormInstance: FormGroup;

  /**
   * triggers when intent changes
   * @param {FormGroup} values
   */
  public set widgetFormInstance(values: FormGroup) {
   this._widgetFormInstance = values;
     if(this.fetchDataBasedOn && this.fetchDataBasedOn === 'stage' && this.init === false) {
       this.init = true;
       this.initSubscriber();
     }
  }

  public get widgetFormInstance() {
    return this._widgetFormInstance;
  }

  public _widgetConfig: IdynamicFormItem;
  public _widgetPayload: IgenericSelectionItem;
  public itemSelectionBindings: any = [];

  /**
   * set widget configuration
   * @param {IdynamicFormItem} _itemConfig
   */
  set widgetConfig(_itemConfig: IdynamicFormItem) {
    this._widgetConfig = _itemConfig;
    this._widgetPayload = _itemConfig.widgetPayload;
    if(get(this._widgetPayload, 'height')) {
      this.selectionPanelHeight = this._widgetPayload.height + 'rem';
    }
    this.itemSelectionBindings = get(this._widgetPayload, 'itemSelectionBindings');
    this.dataModelKeys = get(this._widgetPayload, 'dataModelKeys');
    this.additionalSearchValues = get(this._widgetPayload, 'additionalSearchValues');
    this.configQuery = get(this._widgetPayload, 'configQuery');
    this.configSearchRequest = get(this._widgetPayload, 'configSearchRequest');
    this.datamodelAttributesPayload = get(this._widgetPayload, 'datamodelAttributes');
    this.datamodelContext = get(this._widgetPayload, 'datamodelContext');
    this.noDataMessage = get(this._widgetPayload, 'noDataMessage');
    this.intentDataNotificationForm = get(this._widgetPayload, 'intentDataNotificationForm');
    this.showRecommendedList = get(this._widgetPayload, 'showRecommendedList');
    this.selectionType = get(this._widgetPayload, 'selectionType');
    this.intent = get(this._widgetPayload, 'intent');
    this.tabIntentLabel = get(this._widgetPayload, 'tabIntentLabel');
    this.switchToNewIntent = get(this._widgetPayload, 'switchToNewIntentNotification');
    this.fetchDataBasedOn = get(this._widgetPayload, 'fetchDataBasedOn');
    this.fetchStageData = this.routerManagerService.queryParameters.payload;
    this.recommendedListItem = get(this._widgetPayload, 'recommendedListItem');
    this.expandCollapseRequired = get(this.showRecommendedList, 'expandCollapseRequired') ? get(this.showRecommendedList, 'expandCollapseRequired'): false;
    this.expandRecommendedList = get(this.showRecommendedList, 'expandRecommendedList') ? get(this.showRecommendedList, 'expandRecommendedList'): true;
    this.disableFirstLevel = get(this._widgetPayload, 'disableFirstLevel');
    this.saveOnlyOneIntent = get(this._widgetPayload, 'saveOnlyOneIntent');
    this.tabConfiguration = get(this._widgetPayload, 'tabConfig');
    this.showTextAreaBottom = get(this._widgetPayload, 'showTextAreaBottom');

    if(this.intentDataNotificationForm) {
      this.showDataAvailability(this.intentDataNotificationForm);
    }
    this.getContextAndAttributes();

    if(this.tabConfiguration) {
      this.dataUpdated = false;
      if (!this.isTabInitialised) {
        this.isTabInitialised = true;
        this.createTabConfig(this.tabConfiguration);
        this.mapConfigData(get(this.tabConfig, '[0].config'), get(this.tabConfig, '[0].data'));
        this.currentTabTitle = get(this.tabConfiguration, [0,'defaultTitle']);
      }
      this.initSubscriber(this.currentTabTitle);
      this.createTabs();
    }
  }

  /**
   * Set selected items data and display the selected items count
   * @param widgetData
   */
  set widgetData(widgetData: any) {
    this._widgetData = widgetData;

    if (!isEmpty(this._widgetData) && Array.isArray(this._widgetData)) {
      this.totalSelectedItemList = this.assignItemReference();
      this.groupByCategory();

      this.showItemsCount();
      this._changeDetector.markForCheck();
    }
  }

  constructor(private _formHandlerService: FormHandlerService,
              private _changeDetector: ChangeDetectorRef,
              private _dashboardService: DashboardService,
              private _itemSelectionService: ItemSelectionService,
              private _searchService: SearchService,
              private _getItemsDataService: GetItemsDataService,
              private _getModelContextService: GetModelContextService,
              private authService: AuthenticationService,
              private _dataNotificationService : DataNotificationService,
              private modalLoader: DynamicModalLoaderService,
              private genomicsStore: Store<IgenomicsState>,
              private decisionService: AdditionalConfigurationService,
              private bundleCall: BundleCall,
              private routerManagerService: RouterManagerService) {
                  this._dashboardService.isInoEnabledWithoutAssociation().pipe(take(1)).subscribe((data) => {
                    this._isInoEnabled = data;
                  });
  }

  /**
   * Get user permission based on role
   */
  ngOnInit() {
    this.treeItems.clear();
    this.intentTotalSelectedItems.clear();
    this.getItemsBasedOnCondition();
    if(this._isInoEnabled) {
      this.filterItemBasedOnOrgans();
    }
    this._getModelContextService.getPermission().subscribe(data => {
      this.permitItemSelectionWrite = data;
    });
  }

  groupByCategory() {
    this.groupedSelectedItems = groupBy(this.totalSelectedItemList, function(item) {
      return item['intent'] ? get(item,['intent','code']): item['intent'];
    });
    for (let groupKey in this.groupedSelectedItems) {
      this.intentTotalSelectedItems.set(groupKey, this.groupedSelectedItems[groupKey]);
    }
    this.createTabs();
  }

  /**
   * Assign item reference
   * @returns {any[]}
   */
  assignItemReference():Array<any> {
    this._widgetData.forEach(item => {
      if (item && item !== null && item.hasOwnProperty('formData')) {
        item['itemReferences'] = item[this.dataModelKeys['itemReferences']].references;
      } else if (item && item !== null) {
        item['itemId'] = item[this.dataModelKeys['itemId']];
        item['itemName'] = item[this.dataModelKeys['itemName']];
        item['itemReferences'] = item[this.dataModelKeys['itemReferences']].references;
      }
    });
    return this._widgetData;
  }

  /**
   * Get data if data already updated
   * @param formId
   */
  showDataAvailability(formId){
      this._dataNotificationService.showDataNotification(formId)
        .takeUntil(this.destroyed$.asObservable())
        .subscribe(data => {
          if (!isEmpty(data) && Array.isArray(data) && this.intent && data[this.intent]) {
            this.intentTotalSelectedItems.set(data[0][this.intent], data[0].priority);
          } else if (!isEmpty(data) && !Array.isArray(data) && this.intent && data[this.intent]) {
            this.intentTotalSelectedItems.set(data[this.intent], data.priority);
          }
        });
  }

  /**
   * Add additional attributes to the datamodel
   */
  getContextAndAttributes() {
    this._getModelContextService.getDatamodelAttributes().subscribe( data => {
      for (const prop in this.datamodelAttributesPayload) {
        if (get(data, this.datamodelAttributesPayload[prop])) {
          this.additionalSearchValues[prop] = get(data, this.datamodelAttributesPayload[prop]);
          this.datamodelAttributes[prop] = get(data, this.datamodelAttributesPayload[prop]);
        }
      }
    });

    if (this.fetchDataBasedOn === 'stage') {
      this.datamodelAttributes[this.intent] = {code: this.fetchStageData, display: this.fetchStageData};
    }

    this._getModelContextService.dataModelContext({
      'context': this.datamodelContext,
      'attributes': this.datamodelAttributes
    });
  }

  /**
   * get cancerType and add it to additionalSearchValues
   */
  getItemsBasedOnCondition() {
    if (!isEmpty(this.itemSelectionBindings)) {
      this._getModelContextService.getItemsBasedOnCondition(this.itemSelectionBindings)
        .takeUntil(this.destroyed$.asObservable())
        .filter(queryContextData => !isEmpty(queryContextData))
        .filter(queryContextData => this.itemSelectionBindings.annotatorType === queryContextData.type)
        .subscribe(queryContextData => {
            this.additionalSearchValues['cancerType'] = queryContextData.cancerType;
          }
        );
    }
  }

  /**
   * shows loading spinner
   */
  private intiLoading(){
    this.loading = true;
    if(!this._changeDetector['destroyed']){
      this._changeDetector.detectChanges();
    }
  }

  /**
   * get items data when intent changes
   */
   async initSubscriber(intent?: string) {
    if ((this._widgetConfig && this._widgetFormInstance) || (this.fetchDataBasedOn === 'stage' && this._widgetConfig)) {
      if(intent) {
        const tabKey = find(this.tabConfiguration, tabItem => tabItem['defaultTitle'] === intent);
        this.additionalSearchValues[this.intent] = get(tabKey, 'key');
      }
      this.intentCategory = intent ? this.additionalSearchValues[this.intent] : this._widgetFormInstance.value[this.intent];
      this.intentOrStage = this.fetchDataBasedOn === 'stage' ? this.fetchStageData: this.intentCategory;
      this.intentOrStage = this.intentOrStage && typeof this.intentOrStage === 'object' ? this.intentOrStage['code']:this.intentOrStage;
      this.additionalSearchValues[this.intent] = this.intentOrStage;
      this.restrictItemSelection(this._widgetPayload.restrictItems);
      let foundItems = false;
      this.workflowTestType = await this._getItemsDataService.getWorkflowTestType().then(response => {
        if(!isEmpty(response)) {
          return response.name.replace(/\s/g, "");
        }
      });
      this._getItemsDataService.getAllTreeItems()
        .takeUntil(this.destroyed$.asObservable())
        .subscribe(response => {
          if(response.size > 0 && response.has(this.intentOrStage)
            && response.get(this.intentOrStage).testType === this.workflowTestType
            && response.get(this.intentOrStage).type === get(this.context, ['additionalData','MDTType','code'])) {
            this.categoryItemtList = response.get(this.intentOrStage).list;
            foundItems = true;
            this.loading = false;
            this.treeItems.set(this.intentOrStage, this.categoryItemtList);
            this.showItemsCount();
            this._changeDetector.markForCheck();
          }
        });

      if(this._isInoEnabled) {
        this.genomicsStore.select('tests').take(1).subscribe(data => {
          let permission = this.disableFirstLevel === false ? this.disableFirstLevel : !this.permitItemSelectionWrite;
          if (data.diagnosticOrders.order.testType === "LUNG_Incidental" && permission && this.fetchStageData == "newFindings") {
            if (!this.permitItemSelectionWrite) {
              this.hideDecisions = true;
            }
          }
        });
      }
      if (foundItems === false || typeof this.currentOrgan != 'undefined') {
        this.intiLoading();
        this.context = get(this._widgetFormInstance, 'value');
        const mdtData = await this.genomicsStore.select('currentMDTConfig').take(1).toPromise().then(val => val);
        this.context.additionalData = this.additionalSearchValues;
        this.context.additionalData['kb'] = mdtData?.kb;
        let itemsDataBinding = get(this._widgetPayload, 'itemsDataBinding');
        let additionalNotesDataBinding = get(this._widgetPayload, 'additionalNotesDataBinding', []);
        let additionalDataBinding = cloneDeep(additionalNotesDataBinding);
        let addiConfigPayload = this.queryPayload(additionalDataBinding, 'additionalNotesDataBinding',this.context, this.intentOrStage);
        if (itemsDataBinding) {
          let itemsPayload = this.queryPayload(itemsDataBinding, 'itemsDataBinding',this.context, this.intentOrStage);
          let itemsData = [];
          let resource;
          this._getItemsDataService.getAllItems(itemsPayload, addiConfigPayload)
            .takeUntil(this.destroyed$.asObservable())
            .subscribe(([items,forms]) => {
              if (!isEmpty(items)) {
                let formData = forms[0].response.entry.length > 0 ?
                  forms[0].response.entry[0].resource : forms[0].response.entry[0];
                let itemsResponse = items[0].response.entry;
                itemsResponse.forEach((element) => {
                  resource = element.resource;
                  itemsData.push(resource);
                });
                this.renderItems(itemsData, formData, this.dataModelKeys);
              } else {
                this.noDataNotification();
              }
            });

        } else {
          this._getItemsDataService.getOptionsResourceItems(this._widgetConfig.options.resource, this.context, addiConfigPayload, this._widgetConfig.attributes)
            .takeUntil(this.destroyed$.asObservable())
            .subscribe(([items,forms]) => {
              if (!isEmpty(items)) {
                let formData = forms[0].response.entry.length > 0 ?
                  forms[0].response.entry[0].resource : forms[0].response.entry[0];
                this.renderItems(items, formData, this.dataModelKeys);
              }else {
                this.noDataNotification();
              }
            });
        }

      }
    }
  }

  queryPayload(itemsDataBinding: Array<any>, identifier:string, serachObject, intentValue: string): any {
    let payload = [];
    let identifierKey = {
      'intent': intentValue,
      'queryType': identifier
    };
    if(!this.itemsAndNotesQueryPayload.has(identifierKey)) {
      payload = this._getItemsDataService.formQuery(itemsDataBinding, serachObject);
      this.itemsAndNotesQueryPayload.set(identifierKey, payload);
    } else {
      payload = this.itemsAndNotesQueryPayload.get(identifierKey);
    }
    return payload;
  }

  noDataNotification() {
    this.loading = false;
    this.noData = true;
    this._changeDetector.markForCheck();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  /**
   * Shows the selected items count
   */
  showItemsCount() {
    this.itemsCount = { };
    let groupSelectedItems = this.intent === 'intent' ? this.groupedSelectedItems[this.intentOrStage]: this.totalSelectedItemList;
    let groupedSelectedItemsRef :any = [];
    if (groupSelectedItems && groupSelectedItems.length > 0 && this.categoryItemtList) {
      this.categoryItemtList.forEach(categoryItemList => {
        groupSelectedItems.filter(itemList => {
          if (itemList && itemList.itemReferences && itemList.itemReferences.length > 0 && categoryItemList.itemId === itemList.itemReferences[0].reference) {
            if(itemList.formId){
              const totalItemRef :any=this.totalSelectedItemList.filter((e:any)=>e.formRefName&&e.formRefName==itemList.formRefName);
              if(this.groupedSelectedItems[this.intentOrStage]){
                groupedSelectedItemsRef =this.groupedSelectedItems[this.intentOrStage].filter((e:any)=>e.formRefName&&e.formRefName==itemList.formRefName);
              }
              if(totalItemRef.length>0&&totalItemRef[0].formData&&(totalItemRef[0].formData["notes"] || totalItemRef[0].formData["recommendation"]))
              this.itemsCount[categoryItemList.itemId] = (this.itemsCount[categoryItemList.itemId] || 0) + 1;
            else if(groupedSelectedItemsRef.length>0&&groupedSelectedItemsRef[0].formData&&(groupedSelectedItemsRef[0].formData["notes"] || groupedSelectedItemsRef[0].formData["recommendation"]) )
              if(this.groupedSelectedItems[this.intentOrStage]){
                this.groupedSelectedItems[this.intentOrStage]=this.groupedSelectedItems[this.intentOrStage].filter((e:any)=>e.formRefName&&e.formRefName!=itemList.formRefName);
              }
              this.createTabs()
            }
            else if(itemList.nodeType=="item"){
              const totalItemRef :any=this.totalSelectedItemList.filter((e:any)=>e.itemId&&e.itemId==itemList.itemId);
              if(this.groupedSelectedItems[this.intentOrStage]){
                groupedSelectedItemsRef =this.groupedSelectedItems[this.intentOrStage].filter((e:any)=>e.itemId&&e.itemId==itemList.itemId);
              }
              if(totalItemRef.length>0){
                this.itemsCount[categoryItemList.itemId] = (this.itemsCount[categoryItemList.itemId] || 0) + 1;
              }
            else if(groupedSelectedItemsRef.length>0) {
              if(this.groupedSelectedItems[this.intentOrStage]){
                this.groupedSelectedItems[this.intentOrStage] = this.groupedSelectedItems[this.intentOrStage].filter((e: any) => e.itemId && e.itemId != itemList.itemId);
              }
              this.createTabs()
            }
              }
            else
            this.itemsCount[categoryItemList.itemId] = (this.itemsCount[categoryItemList.itemId] || 0) + 1;
          }
          if (itemList && itemList.itemReferences && itemList.itemReferences.length > 0){
            return (itemList && categoryItemList.itemId === itemList.itemReferences[0].reference);
          }
          else if (itemList && itemList.itemReferences && itemList.itemReferences.length === 0 && categoryItemList.itemId === itemList.itemId) {
            this.itemsCount[categoryItemList.itemId] = (this.itemsCount[categoryItemList.itemId] || 0) + 1;
            return itemList;
          }
        });
      });
    }
  }

  /**
   * create filter to select only organ related option
   */
  filterItemBasedOnOrgans() {
    this.genomicsStore.select('tests').take(1).subscribe(data => {
      let queryString = get(this._widgetPayload, 'decisionDecider');
      const decisionConfig = this.decisionConfigCached.get(queryString);
      if (data && data.diagnosticOrders.order.organ && data.diagnosticOrders.order.organ.length == 1 && typeof queryString !== 'undefined') {
        this.currentOrgan = get(data.diagnosticOrders.order.organ[0], 'code').toString();
        let stage = this.routerManagerService.queryParameters.payload;
        if(!decisionConfig) {
          this.decisionService.fetchDecisionPlans(queryString).subscribe(organDecider => {
            this.decisionConfigCached.set(queryString, organDecider.payload.typeConfig);
            this.organContext = find(organDecider.payload.typeConfig, { organ_name: this.currentOrgan, stage: stage});
            if(typeof this.organContext == 'undefined') {
              this.organContext = find(organDecider.payload.typeConfig, { organ_name: "default", stage: stage});
            }
          });
        } else {
          this.organContext = find(decisionConfig, { organ_name: "default", stage: stage});
        }
      } else if (data.diagnosticOrders.order.organ && data.diagnosticOrders.order.organ.length > 1 && typeof queryString !== 'undefined') {
        this.organContext = false;
      } else if (data && typeof data.diagnosticOrders.order.organ == 'undefined' && typeof queryString !== 'undefined') {
        this.currentOrgan = "lung"
        if(!decisionConfig) {
          this.decisionService.fetchDecisionPlans(queryString).subscribe(organDecider => {
            this.decisionConfigCached.set(queryString, organDecider.payload.typeConfig);
            this.organContext = find(organDecider.payload.typeConfig, { organ_name: this.currentOrgan, stage: this.fetchStageData });
          });
        } else {
          this.organContext = find(decisionConfig, { organ_name: this.currentOrgan, stage: this.fetchStageData });
        }
      }
    });
  }

  /**
   * create tree and render the items in tree format
   * @param itemsData
   * @param {Array<any>} formData
   * @param datamodelKeys
   */
  renderItems(itemsData: any, formData: Array<any>, datamodelKeys: any) {
    this.categoryItemtList = [];
    this.categoryItemtList = this._itemSelectionService.createTreeStructure(itemsData, formData, datamodelKeys);
    if (this.organContext && this.organContext.associatedDiagnosticPlanIds) {
      let result = this.organContext.associatedDiagnosticPlanIds;
      this.organData = filter(this.categoryItemtList, function (item) { return result.includes(item.diagnosticPlanId); });
      this.categoryItemtList = this.organData;
    }
    if (this.organContext == false) {
      this.categoryItemtList = [];
    }
    this.treeItems.set(this.intentOrStage, this.categoryItemtList);

    const treeItemList: Map<string, ItypeTreeList> = new Map();
    this.treeItemsWithIntent = {
      treeItemList: treeItemList
    }
    this.treeItemsWithIntent.treeItemList.set(this.intentOrStage, {
      testType: this.workflowTestType,
      type: get(this.context, ['additionalData','MDTType','code']),
      list: this.categoryItemtList});
    this._getItemsDataService.setAllTreeItem(this.treeItemsWithIntent);

    this.showItemsCount();
    this.loading = false;
    this._changeDetector.markForCheck();
  }

  /**
   * pass the all the sub items of the clicked item
   * @param subItem
   */
  openSubItem(subItem, badgeCount) {
    if(subItem.list.length > 0) {
     subItem.list = sortBy( subItem.list, 'itemName');
      if(!isEmpty(this._widgetData) && Array.isArray(this._widgetData)) {
        this.totalSelectedItemList = this.assignItemReference();
      }
      let notes = [];
      if(Array.isArray(subItem.list) && (get(subItem, this.intent) && includes(this.showTextAreaBottom, get(subItem, [this.intent,'display'])))) {
        this.pncStatus = true;
        subItem.list.forEach(function (value, index)
        {
          if (value.list.length > 0 && value.list[0].nodeType === 'form') {
            notes.push(subItem.list[index]);
            delete subItem.list[index];
          }
        });
        subItem.list=subItem.list.filter(b=>!!b)
        if(notes.length > 0) {
          for (let i = 0; i < notes.length; i++) {
            subItem.list = subItem.list.concat(notes[i]);
          }
        }
      }
      this.subItems = subItem;
      this.selectedSubItems();
      this.subSelectionPanelClose = true;
      this._changeDetector.markForCheck();
      this._changeDetector.detectChanges();
    } else {
      if(this.permitItemSelectionWrite) {
        if (this.restrictItems['maxCount'] && this.totalSelectedItemList
          && this.totalSelectedItemList.length >= this.restrictItems['maxCount']
          && (badgeCount === undefined || badgeCount !== 1)) {
          subItem.selected = false;
          this.showAlertMessages();
        } else {
          let cloneItem = cloneDeep(subItem);
          cloneItem.itemReferences = cloneItem.referencePath;
          this.emitSelectedItems(cloneItem, false);
        }
      }
    }
  }

  /**
   * Popup notification when selected items count exceeds the restrictedCount
   */
  showAlertMessages() {
    this.modalLoader.popupModal(ConfirmModalComponent,
      new ConfirmModalLoaderPayload(
        '',
        ` ${this.restrictItems['message']} ${this.restrictItems['maxCount']}`, '', 'OK'),
      ModalTypes.ALERT)
      .subscribe(res => {
       // this.reset = true;
      });
  }

  /**
   * pass the selected items of the clicked item
   */
  selectedSubItems() {
    if (Array.isArray(this.totalSelectedItemList) && this.totalSelectedItemList.length > 0) {
      if(this.fetchDataBasedOn === 'stage') {
        this.selectedSubItemList = this._itemSelectionService.getGrouppedDataStructure(this.totalSelectedItemList);
      } else if(!isEmpty(this.groupedSelectedItems[this.subItems[this.intent].display])){
        this.selectedSubItemList = this._itemSelectionService.getGrouppedDataStructure(this.groupedSelectedItems[this.subItems[this.intent].display]);
      }
      this.selectedSubItemList = this.selectedSubItemList ? this.selectedSubItemList[this.subItems.itemId] : [];
    } else {
      this.selectedSubItemList = [];
    }
  }

  /**
   * selected items are emitted from child
   * @param selectedItems
   * @param {boolean} nextLevel
   */
  emitSelectedItems(selectedItems : any, nextLevel: boolean = true) {
    this.itemDeleted = false;
    selectedItems = this.datamodelKeys(selectedItems);
    this.totalSelectedItemList = this.totalSelectedItemList ? this.totalSelectedItemList : [];

    const tabKey = find(this.tabConfiguration, tabItem => tabItem['key'] === this.intentCategory);
    if (Array.isArray(selectedItems) && this.fetchDataBasedOn !== 'stage') {
      selectedItems.forEach(item => {
        set(item, [this.intent, 'code'], this.intentCategory);
        set(item, [this.intent, 'display'], get(tabKey, 'defaultTitle'));
      });
    }
    else if (!Array.isArray(selectedItems) && this.fetchDataBasedOn !== 'stage') {
      set(selectedItems, [this.intent, 'code'], this.intentCategory);
      set(selectedItems, [this.intent, 'display'], get(tabKey, 'defaultTitle'));
    }

    this.totalSelectedItemList = this.updatedDeletedItems(selectedItems);
    if(this.intent) {
      this.totalSelectedItemList = this.intentData(selectedItems, nextLevel);
    }
  }

  /**
   * Handled selected items
   * @param selectedItems
   * @param {boolean} nextLevel
   */
  updateSelectedItems(selectedItems: any, nextLevel: boolean = true) {
    if (Array.isArray(selectedItems)) {
      selectedItems = this.handleEmptyItems(selectedItems);
      if(selectedItems.length > 0) {
        this.totalSelectedItemList = [ ...this.totalSelectedItemList, ...selectedItems];
      }
    }

    if (!this.itemDeleted && !Array.isArray(selectedItems)) {
      this.totalSelectedItemList.push(selectedItems);
    }

    if(this.intent) {
      this.intentTotalSelectedItems.clear();
      this.intentTotalSelectedItems.set(this.intentOrStage, this.totalSelectedItemList);
    }
    this._widgetData =  this.totalSelectedItemList;
    if(nextLevel) {
      this.selectedSubItems();
    }
    this.showItemsCount();
    this.emitUpdate();
  }

  /**
   * Handled pushing all the items when intent is not switched, popup notification when switched to new intent
   * @param selectedItems
   * @param {boolean} nextLevel
   * @returns {Array<any>}
   */
  intentData(selectedItems: any, nextLevel: boolean): Array<any> {
    if(this.intentDataNotificationForm && this.intentTotalSelectedItems.size >= 1
      && !this.intentTotalSelectedItems.has(this.intentOrStage) && this.saveOnlyOneIntent) {
      this.showAlertMessage(selectedItems, nextLevel);
    } else {
      this.updateSelectedItems(selectedItems, nextLevel);
    }
    return this.totalSelectedItemList;
  }

  /**
   * Popup notification to clear previous intent data when switch to new intent and select the items
   * @param selectedItems
   * @param {boolean} nextLevel
   */
  showAlertMessage(selectedItems: any, nextLevel: boolean) {
    this.modalLoader.popupModal(ConfirmModalComponent,
      new ConfirmModalLoaderPayload(
        '',
        ` ${this.switchToNewIntent} `, 'Yes', 'Cancel'),
      ModalTypes.ALERT)
      .subscribe(res => {
        if(res.payload === 1) {
          this.intentTotalSelectedItems.clear();
          this.totalSelectedItemList = [];
          this.updateSelectedItems(selectedItems, nextLevel);
        }
      });
  }

  /**
   * handled Updated/deleted items
   * @param selectedItems
   * @returns {Array<any>}
   */
  updatedDeletedItems(selectedItems: any): Array<any> {
    let totalSelectedItems = cloneDeep(this.totalSelectedItemList);
    this.totalSelectedItemList.forEach((item, index) => {
      if (!Array.isArray(selectedItems)) {
        if (isEqual(item.id, selectedItems.id)) {
          totalSelectedItems.splice(index, 1);
          this.itemDeleted = true;
        }
      }
      if (Array.isArray(selectedItems)) {
        selectedItems.forEach(updatedItem => {
          if(this.intent === 'stage') {
            if (isEqual(item.itemReferences, updatedItem.itemReferences) && updatedItem.formData
              && isEmpty(updatedItem.formData[this.recommendedListItem])) {
              let itemIndex = findIndex(totalSelectedItems, function (totalItems) {
                return isEqual(item.itemReferences, totalItems.itemReferences);
              });
              totalSelectedItems.splice(itemIndex, 1);
              updatedItem['deleted'] = true;
              this.itemDeleted = true;
            } else if (isEqual(item.itemReferences, updatedItem.itemReferences) && updatedItem.formData
              && !isEmpty(updatedItem.formData[this.recommendedListItem])) {
              totalSelectedItems.splice(index, 1, updatedItem);
              updatedItem['updated'] = true;
            }
          } else {
            if (isEqual(item.itemReferences, updatedItem.itemReferences) && isEqual(get(item,'intent'), get(updatedItem,'intent'))
              && updatedItem.formData && isEmpty(updatedItem.formData[this.recommendedListItem])) {
              let itemIndex = findIndex(totalSelectedItems, function (totalItems) {
                return isEqual(item.itemReferences, totalItems.itemReferences);
              });
              totalSelectedItems.splice(itemIndex, 1);
              updatedItem['deleted'] = true;
              this.itemDeleted = true;
            } else if (isEqual(item.itemReferences, updatedItem.itemReferences) && isEqual(get(item,'intent'), get(updatedItem,'intent'))
              && updatedItem.formData && !isEmpty(updatedItem.formData[this.recommendedListItem])) {
              totalSelectedItems.splice(index, 1, updatedItem);
              updatedItem['updated'] = true;
            }
          }

        });
      }
    });
    return totalSelectedItems;
  }

  /**
   * Handled when removed content from additional notes
   * @param selectedItems
   * @returns {any}
   */
  handleEmptyItems(selectedItems) {
    selectedItems = selectedItems.filter(item => {
      return (!item['deleted'] && item.formData && !isEmpty(item.formData[this.recommendedListItem]));
    });
    selectedItems = selectedItems.filter(item => {
      return !item['updated'];
    });
    return selectedItems;
  }

  /**
   * updated datamodel key with itemReferences
   * @param selectedItems
   * @returns {any}
   */
  datamodelKeys(selectedItems: any): any {
    if (Array.isArray(selectedItems)) {
      selectedItems.forEach(item => {
        item[this.dataModelKeys['itemReferences']] = { };
        item[this.dataModelKeys['itemReferences']].references = [];
        item[this.dataModelKeys['itemReferences']].references = item['itemReferences'];
      });
    } else {
      selectedItems[this.dataModelKeys['itemReferences']].references = selectedItems['itemReferences'];
    }
    return selectedItems;
  }

  /**
   * emitted Recommended List
   * @param recommendedList
   */
  emitRecommendedItems(recommendedList) {
    if(recommendedList) {
      this._widgetData =  recommendedList;
      this.totalSelectedItemList = this._widgetData;
      this.emitUpdate();
      this.showItemsCount();
    }
  }

  /**
   * triggers an event when coming back to first level
   * @param event
   */
  backwardPanel(event) {
    this.subSelectionPanelClose = event;
  }

  /**
   * emit the data when selected/deleted decisions
   */
  emitUpdate(isInit: boolean = false) {
    if (this.widgetUpdateValueCallback) {
      this.widgetUpdateValueCallback.apply(this, [this._widgetData, isInit]);
    }
  }

  /**
   * Restrict item selection based on stage
   * @param {IrestrictItems} restrictPayload
   */
  restrictItemSelection(restrictPayload: IrestrictItems) {
    this.restrictItems = {};
    if (get(restrictPayload, 'stage')) {
      if (restrictPayload.stage.hasOwnProperty(this.intentOrStage)) {
        this.restrictItems['maxCount'] = restrictPayload.stage[this.intentOrStage];
        this.restrictItems['message'] = restrictPayload.message;
      }
    }else {
      this.restrictItems = this._widgetPayload.restrictItems;
    }
  }

  widgetDataUpdate(tabData: any, isFormInit: boolean) {
    const widgetData = [];
    tabData.forEach(
      eachTab => {
        widgetData.push(...eachTab.data);
      });
  }

  createTabs() {
    this.tabs = [];
    this.tabConfig.forEach(item => {
      this.tabs.push({
        name: item.defaultTitle,
        amount: this.groupedSelectedItems[item.key]?.length || 0
      });
    });
  }

  /**
   * This create the tab config based on the payload,
   * @param payload
   */
  createTabConfig(payload) {
    if (payload) {
      payload.forEach((item) => {
        this.tabConfig.push({
          defaultTitle: item.defaultTitle,
          key: item.key
        });
      });
    }
  }

  /**
   * Based on the title emitted onChange map the relevant config and data .
   * @param tabTitle
   */
  onTabChange(tabTitle) {
    this.initSubscriber(tabTitle);
    this.currentTabTitle = tabTitle;
    this.tabsHeaderComponent.currentTab = this.currentTabTitle;
  }

  mapConfigData(config, data) {
    this.formConfig = config;
    if (!isEqual(this.formData,data)) {
      this.formData = data;
    }
  }

  onFormInit(data, index) {
    const tabConfig = this.tabContainer.find(tabData => this.currentTabTitle === tabData.tabName);
  }

  }
